import { HttpService } from './HttpService';

export class PushNotificationService extends HttpService {

    constructor(url: string) {
        super(url);
        this.registerEvents();
    }

    public registerToken() {
        return new Promise((resolve, reject) => {
            const OneSignal = window.OneSignal || [];
            OneSignal.push(() => {
                OneSignal.isPushNotificationsEnabled((isEnabled: any) => {
                    if (isEnabled) {
                        OneSignal.getUserId((token: any) => {
                            console.log("OneSignal token", token);
                            this.post("/auth/registerToken", {
                                token: token
                            }).then((result) => {
                                if (result.data.error) {
                                    reject({
                                        errorMessage: result.data.error
                                    });
                                }
                                resolve(result.data.success);
                            }).catch((error) => {
                                reject({
                                    errorMessage: "Error during register token request"
                                });
                            });
                        });
                    }
                });
            });
        });
    }

    private registerEvents() {
        console.log("Registering OneSignal events");

        const OneSignal = window.OneSignal || [];

        OneSignal.push(["addListenerForNotificationOpened", (event: any) => {
            console.log("OneSignal notification clicked:", event);
        }]);

        OneSignal.push(() => {
            window.OneSignal.on('notificationDisplay', (event: any) => {
                console.warn('OneSignal notification displayed:', event);
                if (event && event.data) {
                    alert(event.data.notificationType);

                    if (event.data.notificationType === "orderCreated") {
                        window.location.reload();
                        //window.location.href = "/waiter/home";
                    }

                    if (event.data.notificationType === "orderUpdated") {
                        window.location.reload();
                        //window.location.href = "/waiter/home";
                    }

                    if (event.data.notificationType === "orderPaid") {
                        window.location.reload();
                        //window.location.href = "/waiter/home";
                    }
                }
            });
        });

        OneSignal.push(() => {
            window.OneSignal.on('notificationDismiss', (event: any) => {
                console.warn('OneSignal notification dismissed:', event);
            });
        });
    }
}